module.exports = __webpack_public_path__ + "static/media/createCase.742ff6c3.svg";